const PRODUCT_IMAGE_PATH = /^(.*\/uploads\/products\/images)\/([^/?#]+)$/

/**
 * Миниатюра загруженного фото товара (300 px). Карточки каталога тянули оригиналы
 * до 10 МБ: на странице из 20 товаров это сотни мегабайт. Для остальных URL (внешние,
 * заглушки) возвращает null.
 */
export function productThumbnailUrl(url: string): string | null {
  const match = PRODUCT_IMAGE_PATH.exec(url)
  return match ? `${match[1]}/thumbnails/${match[2]}` : null
}
